// import camelCase from "lodash/camelCase";
import { format, isValid, parseISO } from "date-fns";
import isFinite from "lodash/isFinite";
import snakeCase from "lodash/snakeCase";

import { citiesData } from "components/pages/home/content/cities";
import { DEFAULT_AMENITIES, DEFAULT_GUESTS } from "components/store/source";

export function paramToCity(cityParam, t) {
  // TODO: city is null when on Home page. Home should have its own context instead
  // TODO: after the refactor, we should make it an object and remove all the formatting/normalizing
  return {
    destination: cityParam ? t(citiesData[cityParam]?.translateKey) : null,
  };
}

export function paramToGuests(guestsParam) {
  return {
    // note: this is nested in case we want to add different guest count types in the future e.g. children/elderly
    guests: {
      guests: parseInt(guestsParam, 10) || DEFAULT_GUESTS,
    },
  };
}

export function paramToDates(startDate = "", endDate = "") {
  const getDate = date => (isValid(parseISO(date)) ? date : null);

  return {
    checkIn: getDate(startDate),
    checkOut: getDate(endDate),
  };
}

export function paramToNeighborhood(neighborhoodParam) {
  return {
    // TODO: store the entire label/value object in neighborhood context
    neighborhood: (neighborhoodParam || "all_neighborhoods").replace("+", " "),
  };
}

function tryJSONParsePrice(pricesParam) {
  try {
    return JSON.parse(pricesParam);
  } catch {
    return [null, null];
  }
}

export function paramToPrices(pricesParam) {
  const [priceMin, priceMax] = pricesParam
    ? tryJSONParsePrice(pricesParam)
    : [null, null];

  return {
    priceMin,
    priceMax,
  };
}

export function pricesToParam(prices = {}) {
  const formatted = [prices.priceMin, prices.priceMax].filter(isFinite);
  return formatted.length
    ? {
        prices: JSON.stringify(formatted),
      }
    : {};
}

export function paramToCounter(param, count) {
  if (!param || !count) return {};
  // TODO: store as camelCase e.g. bedroomCount instead of bedroom_count
  // const camelized = camelCase(name);
  return {
    [param]: count ? parseInt(count, 10) : DEFAULT_AMENITIES[param],
  };
}

export function countersToParam(counters = {}) {
  const counterKeys = Object.keys(DEFAULT_AMENITIES);
  return counterKeys.reduce((params, counter) => {
    const value = counters[counter];
    if (value || value === 0) {
      params[snakeCase(counter)] = value;
    }
    return params;
  }, {});
}

export function paramToAmenities(amenitiesParam = "") {
  return amenitiesParam
    .split(",")
    .filter(amenity => amenity)
    .reduce((acc, amenity) => {
      // TODO: store as camelCase
      // acc[camelCase(amenity)] = true;
      acc[amenity] = true;
      return acc;
    }, {});
}

export function paramToSortBy(sortBy) {
  if (!sortBy) return {};

  return { sortBy: sortBy };
}

export function paramToBuildingId(buildingId) {
  if (!buildingId) return {};

  return { buildingId: buildingId };
}

export function paramToGeoBounds(geoBounds) {
  if (!geoBounds) return null;

  const [neLat, neLng, swLat, swLng] = geoBounds.split(",");

  return {
    geoBounds: {
      ne: {
        lat: neLat,
        lng: neLng,
      },
      sw: {
        lat: swLat,
        lng: swLng,
      },
    },
  };
}

export function paramToGeoDistance(geoDistance) {
  if (!geoDistance) return null;

  const [lat, lng, distance] = geoDistance.split(",");

  return {
    geoDistance: {
      center: {
        lat,
        lng,
      },
      distance,
    },
  };
}

export function amenitiesToParam(amenities = {}) {
  const counters = Object.keys(DEFAULT_AMENITIES);
  const amenitiesString = Object.keys(amenities)
    .filter(amenity => !counters.includes(amenity))
    .join(",");
  return amenitiesString.length
    ? {
        amenities: amenitiesString,
      }
    : {};
}

export function sortByToParam(sortBy) {
  if (!sortBy) return {};

  return { sort_by: sortBy };
}

export const updateSearchPath = path => {
  if (typeof window !== "undefined") {
    window.history.replaceState(null, "", path);
  }
};

export const buildListingURL = ({
  baseUrl,
  listingUrl,
  id,
  checkIn,
  checkOut,
  sleeps,
  priceMin,
  priceMax,
}) => {
  if (!baseUrl || !listingUrl || !id) {
    return;
  }
  const params = [];
  if (checkIn && checkOut) {
    const dataFormat = "yyyy-MM-dd";

    const checkInDate = format(parseISO(checkIn), dataFormat);
    params.push(`check_in_dt=${checkInDate}`);

    const checkOutDate = format(parseISO(checkOut), dataFormat);
    params.push(`check_out_dt=${checkOutDate}`);
  }
  if (sleeps) {
    params.push(`sleeps=${sleeps}`);
  }
  if (priceMin && priceMax) {
    params.push(`prices=${encodeURIComponent(`[${priceMin},${priceMax}]`)}`);
  }
  let paramsStr = "";
  let prefix = "?";
  params.forEach(param => {
    paramsStr += prefix + param;
    prefix = "&";
  });
  return `${baseUrl}/${listingUrl}/c${id}${paramsStr}`;
};
